import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { selectSendCodeDisabled, sendTwoFactorAuthEmailSetupCode } from "./TwoFactorAuthenticationSlice";
import { useSelector } from "react-redux";

export default function TwoFactorEmailDisplay() {
  const sendCodeDisabled = useSelector(selectSendCodeDisabled);
  const thunkDispatch = useThunkDispatch();

  const onClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    thunkDispatch(sendTwoFactorAuthEmailSetupCode());
  };

  return (
    <>
      <div className="email-setup-section">
        <div>
          Send a verification code to your email using the button below. If you can't see the email, make sure you check
          your spam folder.
        </div>
        <button
          onClick={onClick}
          disabled={sendCodeDisabled}
          className="cpl-btn cpl-btn-outline btn-sm mx-auto"
          data-test-id="two-factor-email-setup__send-code-button"
        >
          {sendCodeDisabled ? "Verification code sent" : "Send verification code"}
        </button>
      </div>
    </>
  );
}
